import { configureStore } from "@reduxjs/toolkit";
import { cryptoApi } from "../services/cryptoApi";
import { cryptoCoin } from "../services/cryptoCoinsApi";
import { cryptoNews } from "../services/cryptoNewsApi";
export default configureStore({
  reducer: {
    [cryptoApi.reducerPath]: cryptoApi.reducer,
    [cryptoCoin.reducerPath]: cryptoCoin.reducer,
    [cryptoNews.reducerPath]: cryptoNews.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(cryptoApi.middleware)
      .concat(cryptoCoin.middleware)
      .concat(cryptoNews.middleware),
});
